import IncentiveOfferDetail from 'modules/incentivesMarket/pages/IncentiveOfferDetail';
import { IncentiveOfferDetailProvider } from '../pages/IncentiveOfferDetail/context/IncentiveOfferDetailContext';

const IncentiveOfferDetailContainer = () => (
  <IncentiveOfferDetailProvider>
    <IncentiveOfferDetail />
  </IncentiveOfferDetailProvider>
);

export default IncentiveOfferDetailContainer;
